// FORMAT TIMESTAMP YYYY-MM-DD HH:MM:SS
export function formatTimeStamp(date) {
    if (!(date instanceof Date)) {
      date = new Date(date); // Convert string or number to Date object if necessary
    }
  
    // Format date: Month DD, YYYY
    const options = { year: 'numeric', month: 'long', day: '2-digit' };
    const formattedDate = date.toLocaleDateString('en-US', options);
  
    // Format time: HH:MM AM/PM
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert to 12-hour format
    const formattedTime = `${hours}:${minutes} ${ampm}`;
  
    return [formattedDate, formattedTime];
  }
  